import { FunctionComponent, PropsWithChildren, useState } from 'react';

import { LayoutContext } from '.';
import { LayoutEnum } from '../enums';

const LayoutProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const [layout, setLayout] = useState(LayoutEnum.BASE_LAYOUT);

  const value = {
    layout,
    setLayout,
  };

  return <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>;
};

export default LayoutProvider;
